module.exports = __webpack_public_path__ + "static/img/1.18afb07.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/zh/1.png
// module id = vgbV
// module chunks = 0